import { render, staticRenderFns } from "./landingRobotics-wayne.vue?vue&type=template&id=4b18168f&scoped=true&"
import script from "./landingRobotics-wayne.vue?vue&type=script&lang=js&"
export * from "./landingRobotics-wayne.vue?vue&type=script&lang=js&"
import style0 from "./landingRobotics-wayne.vue?vue&type=style&index=0&id=4b18168f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b18168f",
  null
  
)

export default component.exports